import { Component } from '@angular/core';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { debtorsRequest, debtorsResponse } from '../../interface/data.interface';
import { CompaniesFactoringService } from '../../../factoring/services/companies-factoring.service';
import { delay, finalize } from 'rxjs';

@Component({
  selector: 'app-debtor-black-list',
  templateUrl: './debtor-black-list.component.html',
  styleUrls: ['./debtor-black-list.component.scss']
})
export class DebtorBlackListComponent {
  deudores: PageResult<debtorsResponse>;
  booleanFlag: boolean = false;
  booleanText: boolean = false;
  public dashboardFilter: debtorsRequest;
  
  constructor(private factoringService: CompaniesFactoringService) {
    this.deudores = {
      ...this.deudores,
      results: [],
    };

    this.dashboardFilter = {page:1, size:10, search:'', sortOrder:'' };
   }


   ngOnInit() {
    this.getAllDebtors();
  }

  public receiveProviderPaginationChange(changePagination: any) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      page: changePagination.page,
      size: changePagination.size,
    };

    this.getAllDebtors(); 
  }

  receiveChangeSortingOrder(sortOrder: string) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      sortOrder: sortOrder
    }
    this.getAllDebtors(); 
  }

  async receiveFilterGeneral(event: string) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      search: event,
    };

    this.getAllDebtors();
  }

  actualizarData(data: any) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
    };
    this.getAllDebtors();
  }

  public getAllDebtors() {
    this.booleanFlag = true
    this.booleanText = true
    this.factoringService
      .getDebtorsBlackList(this.dashboardFilter)
      .pipe(
        delay(1500),
        finalize(() => { this.booleanFlag = false }),
      )
      .subscribe({
        next: (response) => {
          if (response.results.length == 0) {
            this.booleanText = false
          }
          this.deudores = response;
          this.booleanFlag = false
        },
        error: (e) => {
          console.log(e)
        },
        complete: () => {
          this.booleanFlag = true
        }
      }); 
  }

}
